module Tapas.Bindings {
    export class FloatingMenu {
        public init(element: any, valueAccessor: () => any, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {
            if (!bindingContext)
                return;

			var _ele = $(element);
			var floatingPosition = _ele.offset();

			$(document).scroll(function () {
				var y = $(this).scrollTop();
                

                if (!_ele.hasClass('float')) {
                    $('.js-wrapper').css('padding-top', _ele.height());
                    $('.js-topbar').addClass('transparent');
                }

				if (y >= floatingPosition.top) {
					_ele.addClass("float");
				}
				else {
                    _ele.removeClass("float");
                    $('.js-topbar').removeClass('transparent');
                    $('.js-wrapper').css('padding-top', 0);
				}
			});
        }
    }
    ko.bindingHandlers['floatingMenu'] = new FloatingMenu();
} 
